import React, { useState, useEffect,useContext} from "react";

import { AppContext } from "../../AppContext";

import DateUtil from "../../common/dateUtil";

import PoliticalFormComp from "./PoliticalFormComp";
import PoliticalPreviewComp from "./PoliticalPreviewComp";
import { fetchCall } from "../../common/FetchHelpers";

const PoliticalEditorComp = (props) => {
  
  const reqUrl = "api/political/create";

  const emptyFormData = {
    id:-1,
    status:"",
    contribType : "Contribution",
    description : "",
    contribAmount:"",
    currency:"",
    contribDate : "",
    reqMsrb:"N",
    isCampaign:"N",
    campaign:"",
    stateProv:"",
    politicalParty:"",
    attachment:null,
    officials:[
      {name:'',title:'',agency:''},
      {name:'',title:'',agency:''}
    ],
    contributorType:"",
    spouseLastName:"",
    spouseMiddleName:"",
    spouseFirstName:"",
    contribTarget:"",
    politicalOrganizationType:"",
    politicalPartyVoteJurisdiction:"",
    politicalOrganizationName:"",
    politicalOrganizationJurisdiction:"",
    candidateName:"",
    officeSought:"",
    electionDate:"",
    officeSoughtJurisdiction:"",
    electionType:"",
    officeHeld:"",
    contribPaymentType:"",
    candidateContribAmount:"",
    otherPaymentMethod:"",
    otherContribMethod:"",
    engagementInWorkingHours:"",
    engagementHours:"",
    usingOfficeResource:"",
    contribIndividualOrPac:"IN",
    contribIndividualSoughtPosition:"",
    contribIndividualHoldOffice:"N",
    contribIndividualActivePosition:"",
    contributorEligibleToVote:"N",

    isIndividualPriorContrib:"",
    individualPriorContribDetail:"",
    individualPriorContribDate:"",
    individualPriorContribAmount:"",
    individualPriorContribCampaignOrganization:"",
    isCandidateAssociated:"",
    candidateAssociatedDesc:"",
    isCandidateClient:"",

    submittedFor:null
  }

  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;
  const [showError, setShowError] = useState(false);

  const [showEditor, setShowEditor] = useState(true);
  const [showPreview, setShowPreview] = useState(false);

  const [detailMode, setDetailMode] = useState("PREVIEW");
  const [formData, updateFormData] = useState(props.formData);

  const handleChange = (e) => {
    if(e.target.name === 'submittedFor') {
      updateFormData({...formData, [e.target.name]: e.target.value, submittedForLabel: e.target.label});
    } else{
      const value = (e.target.files && e.target.files[0])?e.target.files[0]:e.target.value;
      updateFormData({...formData,[e.target.name]:value});
    }
  };

  const handleDateChange = (date,name) => {
    updateFormData({
      ...formData,
      [name]: date
    });
  };


  const [officials,setOfficials] = useState(props.formData.officials);

  const officialAdd = ()=>{
    setOfficials(officials=>[...officials,{name:'',title:'',agency:''}]);
  };

  const officialRemove = (idx)=>{
    //console.log(officials.length);
    if(officials.length>1){
        const temp = [...officials];
        temp.splice(idx, 1);
        setOfficials(temp);
    }else{
      setOfficials([{name:'',title:'',agency:''}]);
    }
  };

const officialChanged = (e,idx)=>{
    let newArr = [...officials];
    newArr[idx] = {...newArr[idx], [e.target.name]:e.target.value};
    setOfficials(newArr);
}


  const handleSaveClick = () => {
      updateFormData({
        ...formData,
        officials
      });

      setShowEditor(false);
      setShowPreview(true);
    
  };

  const handleSubmit = () => {
    if (detailMode == "PREVIEW") {
      setDetailMode("POSTREVIEW");

      let contribDate = DateUtil.toStrDate(formData.contribDate);

      const fData = new FormData();
      fData.append("id",formData.id);
      fData.append("status",formData.status);
      fData.append("contribType",formData.contribType);
      
      if (formData.description)
        fData.append("description",formData.description);
      fData.append("contribAmount",formData.contribAmount);
      fData.append("currency",formData.currency);
      fData.append("contribDate",contribDate);
      fData.append("reqMsrb",formData.reqMsrb);
      fData.append("campaign",formData.campaign);
      fData.append("isCampaign",formData.isCampaign);
      fData.append("stateProv",formData.stateProv);
      fData.append("politicalParty",formData.politicalParty);
      fData.append("file",formData.attachment);
      fData.append("contribIndividualOrPac", formData.contribIndividualOrPac);
      if (formData.contribIndividualSoughtPosition)
        fData.append("contribIndividualSoughtPosition", formData.contribIndividualSoughtPosition);
      if (formData.contribIndividualHoldOffice)
        fData.append("contribIndividualHoldOffice", formData.contribIndividualHoldOffice);
      if (formData.contribIndividualActivePosition)
        fData.append("contribIndividualActivePosition", formData.contribIndividualActivePosition);

      fData.append("contributorEligibleToVote", formData.contributorEligibleToVote);

      if(formData.submittedFor)
        fData.append("submittedFor",formData.submittedFor);

      if(isJwCole){
        const otherJwColeContribution = {

          contributorType : formData.contributorType,
          spouseLastName : formData.spouseLastName,
          spouseMiddleName : formData.spouseMiddleName,
          spouseFirstName : formData.spouseFirstName,
          contribTarget : formData.contribTarget,
          politicalOrganizationType : formData.politicalOrganizationType,
          politicalPartyVoteJurisdiction : formData.politicalPartyVoteJurisdiction,
          politicalOrganizationName : formData.politicalOrganizationName,
          politicalOrganizationJurisdiction : formData.politicalOrganizationJurisdiction,
          candidateName : formData.candidateName,
          officeSought : formData.officeSought,
          electionDate : DateUtil.toStrDate(formData.electionDate),
          officeSoughtJurisdiction : formData.officeSoughtJurisdiction,
          electionType : formData.electionType,
          officeHeld : formData.officeHeld,
          contribPaymentType : formData.contribPaymentType,
          candidateContribAmount : formData.candidateContribAmount,
          otherPaymentMethod : formData.otherPaymentMethod,
          otherContribMethod: formData.otherContribMethod,

          isIndividualPriorContrib: formData.isIndividualPriorContrib,
          individualPriorContribDetail: formData.individualPriorContribDetail,
          individualPriorContribDate: DateUtil.toStrDate(formData.individualPriorContribDate),
          individualPriorContribAmount: formData.individualPriorContribAmount,
          individualPriorContribCampaignOrganization: formData.individualPriorContribCampaignOrganization,
          isCandidateAssociated: formData.isCandidateAssociated,
          candidateAssociatedDesc: formData.candidateAssociatedDesc,
          isCandidateClient: formData.isCandidateClient,

        }

        const otherJwColeDonation = {
          politicalOrganizationName : formData.politicalOrganizationName,
          politicalOrganizationType : formData.politicalOrganizationType,
          officeSought : formData.officeSought,
          officeSoughtJurisdiction : formData.officeSoughtJurisdiction,
          officeHeld : formData.officeHeld,
          electionDate : DateUtil.toStrDate(formData.electionDate),
          contributePersonalFund: formData.contributePersonalFund,
          engagementInWorkingHours: formData.engagementInWorkingHours,
          engagementHours: formData.engagementHours,
          usingOfficeResource: formData.usingOfficeResource,

        }

        const otherData = (formData.contribType === "Contribution")?otherJwColeContribution:otherJwColeDonation;
        fData.append("formData",JSON.stringify(otherData));
    }

    console.log(formData);

      if(formData.officials && formData.officials.length>0){

        formData.officials.map((item,idx)=>{
          if(item.name || item.title || item.agency){
            fData.append("officials["+idx+"].name",item.name||"");
            fData.append("officials["+idx+"].title",item.title||"");
            fData.append("officials["+idx+"].agency",item.agency||"");
          }
        });

      }


      const reqOptions = {
        method: "POST",
        body: fData
      };

      fetchCall(reqUrl, reqOptions)
        .then((result)=>{
          if(props.editorMode === "NEW"){
            setAppContext({ ...appContext, reloadSummary: true });
          }
          setDetailConfig({
            ...detailConfig,
            detailMode:"POSTREVIEW",
            title: "Request submitted",
            status: {
              state: "success",
              message: "Request successfully submitted",
            },
            btnOk: {
              ...detailConfig.btnOk,
              label: "Add Another request",
            },
            btnCancel: {
              label: "Close",
              handler: props.handleClose,
            },
          });
        })
        .catch((err)=>{
          console.log("Error, with message:", err.statusText);
          setShowEditor(false);
          setShowPreview(false);
          setShowError(true);
        }
      );
    } else {
      console.log("Add Another Clicked");
      handleAddAnother();
    }

  };

  const handleClosePreview = () => {

    setShowEditor(true);
    setShowPreview(false);
  };


  const handleAddAnother = () => {
    setDetailMode("PREVIEW");
    setDetailConfig(defaultConfig);
    updateFormData(emptyFormData);
    setOfficials(emptyFormData.officials);
    handleClosePreview();
  };



  const defaultConfig = {
    editorMode:props.editorMode,
    detailMode:detailMode,
    title: "Review your request before submitting",
    status: {
      state: "",
      message: "",
    },
    btnOk: {
      label: "Submit",
      handler: handleSubmit,
    },
    btnCancel: {
      label: "Edit Before Submit",
      handler: handleClosePreview,
    },
  };
  const [detailConfig, setDetailConfig] = useState(defaultConfig);

  useEffect(()=>{
    console.log(formData);
  },[formData])

  return (
    <>
      {showPreview && (
        <PoliticalPreviewComp
          config={detailConfig}
          data={formData}
          btnOk={{
            label: detailConfig.btnOk.label,
            handler: handleSubmit,
          }}
        />
      )}

      {showEditor && (<PoliticalFormComp
        editorMode={props.editorMode}
        data={formData}
        handleChange={handleChange}
        handleDateChange={handleDateChange}
        handleSaveClick={handleSaveClick}
        handleCancel={props.handleClose}

        officials={officials}
        officialAdd={officialAdd}
        officialRemove={officialRemove}
        officialChanged={officialChanged} 
      />)}
      
    </>
  );
};
export default PoliticalEditorComp;
